export default "__VITE_ASSET__DDhDE2k8__"